import { useState, useEffect } from 'react';

const MESSAGES = [
  'Bravo, hai creato un buco nero che ha pulito tutta la sabbia.',
  'Come premio ecco un bello spettacolo',
];
const CHAR_DELAY = 32;   // ms per character
const PAUSE_MS   = 1400; // pause between messages / before onDone

export function EasterEggMessage({ onDone }) {
  const [msgIdx, setMsgIdx] = useState(0);
  const [text,   setText]   = useState('');
  const [done,   setDone]   = useState(false);

  useEffect(() => {
    if (done) return;
    const full = MESSAGES[msgIdx];
    if (text.length < full.length) {
      const t = setTimeout(() => setText(full.slice(0, text.length + 1)), CHAR_DELAY);
      return () => clearTimeout(t);
    }
    // Current message fully typed → pause, then advance or finish
    const t = setTimeout(() => {
      if (msgIdx < MESSAGES.length - 1) {
        setMsgIdx(i => i + 1);
        setText('');
      } else {
        setDone(true);
        onDone?.();
      }
    }, PAUSE_MS);
    return () => clearTimeout(t);
  }, [text, msgIdx, done, onDone]);

  return (
    <div className="mt-3 max-w-xs flex flex-col gap-1">
      {/* Previously completed messages */}
      {MESSAGES.slice(0, msgIdx).map((m, i) => (
        <p key={i} className="text-[var(--color-muted)] text-xs leading-relaxed opacity-70">
          {m}
        </p>
      ))}
      {/* Currently typing message */}
      {!done && (
        <p className="text-[var(--color-accent)] text-xs leading-relaxed">
          {text}
          <span className="animate-pulse">▌</span>
        </p>
      )}
    </div>
  );
}
